import { render } from "./ChiCken.vue?vue&type=template&id=5acf6a6e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/ChiCken.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5acf6a6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5acf6a6e', __exports__)) {
    api.reload('5acf6a6e', __exports__)
  }
  
  module.hot.accept("./ChiCken.vue?vue&type=template&id=5acf6a6e", () => {
    api.rerender('5acf6a6e', render)
  })

}


export default __exports__